import { createTheme } from '@mui/material/styles';

const uteRed = '#CC0000';
const byuBlue = '#0062B8';
const gray = '#686868';
const green = '#076652';
//const black = '#000000';

export default createTheme({
	palette: {
		common: {
			red: `${uteRed}`,
			blue: `${byuBlue}`,
			gray: `${gray}`,
			green: `${green}`
		},
		primary: {
			main: `${byuBlue}`
		},
		secondary: {
			main: `${byuBlue}`
		}
	},
	typography: {
		tab: {
			fontFamily: 'Arial',
			textTransform: 'none',
			fontWeight: 700,
			fontSize: '1rem',
			color: 'White'
		}
	}
});
